import React from 'react';

import styles from './styles/input-filter.module.css';

import {ReactComponent as Search} from '../../assets/docs-women/search-filter.svg';

export default function InputFilter({ type, placeholder, name, value, handleChange }) {
    return (
        <div className={styles.wrapper} datatype={type}>
            <Search />
            <input
                placeholder={placeholder}
                name={name}
                value={value || ''}
                onChange={handleChange}
                autoComplete='off'
            />
        </div>
    );
}
